import React, { PureComponent } from "react";
import PropTypes from "prop-types";
import { Button, Tooltip, Modal, message, Select } from "antd";
import { request, BaseComponent } from '@cm-sites-webber/components';
import { PositionTypeContext } from '../../PositionAdd';

/**
 * 危险处置人字段
 */
class Disposer extends BaseComponent {
    constructor(props) {
        super(props);

        this.state = {
            fieldProps: {},
            suffixWidth: 0,
            value: ""
        };

        this.suffixDomRef = React.createRef();
    }

    componentDidMount(){
        const observer = new ResizeObserver((e,o)=>{
            this.setState({
                suffixWidth: e[0].contentRect.width + 5 + 32,  //添加间距
            })
        });
        if (this.suffixDomRef.current) {
            observer.observe(this.suffixDomRef.current);
        }else {
            this.setState({
                suffixWidth: 0,
            })
        }
        this.setState({
            value: this.props.fieldProps?.userInfo?.text
        })
    }

    componentWillUnmount(){
        // 解决异常组件卸载调用setState
        this.setState = ()=>{}
    }

    static getDerivedStateFromProps(props,state) {
        // 判断props中的属性
        if (props.fieldProps&&state !== props.fieldProps) {
            let newProps = {};
            for (const key in props) {
                if (!Object.hasOwnProperty.call(Disposer.defaultProps, key)) {
                    newProps[key] = props[key];
                }
            }
            for (const fieldKey in props.fieldProps) {
                if(Array.isArray(props.fieldProps?.extra)&&!props.fieldProps?.extra.includes(fieldKey) ){
                    newProps[fieldKey] = props.fieldProps[fieldKey];
                }
            }

            return {...state,fieldProps:{...newProps}}
        }
        return state
    }

    render() {
        const {value} = this.state;
        return (
            <div className={"position-manage-detail-value"}>
                {value}
            </div>
        )
    }

}
export default Disposer;

Disposer.propTypes = {
    suffixButton: PropTypes.bool,
    prefixLayout: PropTypes.node,
    suffixLayout: PropTypes.node,
    style: PropTypes.object,
    fieldProps: PropTypes.object,
}

Disposer.defaultProps = {
    prefixLayout: null,
    suffixButton: false,
    suffixLayout: null,
    style: {},
    fieldProps: {},
    setFiledValidateStatus: ()=>{}
}